
import TitleBox from '@/components/CSS/TitleBox'
import ExchangeSuccessModal from '@/components/EquityExchange/ExchangeSuccessModal'

export default {
	name: 'EquityExchange',
	components: {
		TitleBox,
		ExchangeSuccessModal
	},
	data() {
		return {
			cdkeyCode: '',
			exchanging: false,
			showSuccessModal: false,
			exchangeItems: []
		}
	},
	// 页面激活时重置状态
	activated() {
		this.resetPageState()
	},
	// 页面销毁时清理状态
	beforeDestroy() {
		this.resetPageState()
	},
	methods: {
		// 重置页面状态
		resetPageState() {
			this.cdkeyCode = ''
			this.exchanging = false
			this.showSuccessModal = false
			this.exchangeItems = []
		},
		async handleExchange() {
			if (!this.cdkeyCode.trim()) {
				this.$message.warning('请输入兑换码')
				return
			}

			// 防止重复提交
			if (this.exchanging) {
				return
			}

			// 输入验证
			const cdkey = this.cdkeyCode.trim()
			if (cdkey.length < 3) {
				this.$message.warning('兑换码长度不能少于3位')
				return
			}

			if (cdkey.length > 50) {
				this.$message.warning('兑换码长度不能超过50位')
				return
			}

			this.exchanging = true
			try {
				// 第一步：调用兑换接口
				const exchangeRes = await this.$api.exchangeCdkey({
					 code: cdkey
				})
				
				if (exchangeRes.success) {
					// 兑换成功，获取兑换码
					const exchangeCode = exchangeRes.data.code
					
					if (exchangeCode) {
						// 第二步：调用详情接口获取优惠券信息
						const detailRes = await this.$api.exchangeCdkeyDetail({
							code: exchangeCode
						})
						
						if (detailRes.success && detailRes.data && detailRes.data.length > 0) {
							// 格式化兑换项目数据
							this.exchangeItems = detailRes.data.map(item => ({
								value: `¥${item.couponsValue || 0}`,
								title: item.name || '未知权益',
								expireTime: item.useEndTime || '未知时间'
							}))
							
							// 显示成功弹窗
							this.showSuccessModal = true
							this.cdkeyCode = ''
							
							// 刷新用户券包数据
							this.$store.dispatch('user/UserCenterCouponDot')
						} else {
							// 详情接口返回成功但没有数据
							this.$message.success('兑换成功！')
							this.cdkeyCode = ''
						}
					} else {
						// 兑换成功但没有返回兑换码
						this.$message.success('兑换成功！')
						this.cdkeyCode = ''
					}
				} else {
					// 兑换接口返回业务错误
					this.$message.error(exchangeRes.info || exchangeRes.message || '兑换失败，请重试')
				}
			} catch (error) {
				console.error('权益兑换接口调用失败:', error)
				
				// 避免与httpErrorStatusHandle重复显示错误信息
				// httpErrorStatusHandle已经处理了大部分HTTP错误，我们只需要处理特殊情况
				
				if (error.response) {
					// 服务器响应错误 - 大部分情况httpErrorStatusHandle已经处理
					const status = error.response.status
					
					// 只处理httpErrorStatusHandle没有处理的特殊情况
					if (status === 400 && error.response.data?.message) {
						// 400错误可能有具体的业务错误信息，需要显示
						this.$message.error(error.response.data.message)
					} else if (status === 429) {
						// 429错误可能需要特殊处理
						this.$message.error('兑换过于频繁，请稍后再试')
					} else if (status >= 500) {
						// 5xx错误httpErrorStatusHandle已经处理，不需要重复显示
						// 但可以记录日志
						console.error('服务器错误:', status, error.response.data)
					}
					// 其他状态码由httpErrorStatusHandle处理，不需要重复显示
				} else if (error.request) {
					// 网络请求错误 - httpErrorStatusHandle已经处理
					console.error('网络请求错误:', error.request)
				} else {
					// 其他错误（如业务逻辑错误）
					this.$message.error(error.message || '兑换失败，请重试')
				}
			} finally {
				this.exchanging = false
			}
		},
		// 处理输入框回车事件
		handleKeyPress(event) {
			if (event.key === 'Enter') {
				this.handleExchange()
			}
		},
		// 清空输入框
		clearInput() {
			this.cdkeyCode = ''
		},
		handleCloseModal() {
			this.showSuccessModal = false
			this.exchangeItems = []
		}
	},
	head() {
		return {
			title: '权益兑换-个人中心-盼之代售-手游网游账号买号卖号平台',
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: '盼之代售权益兑换中心，支持CDkey兑换各种游戏权益和优惠券。'
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: '权益兑换，CDkey兑换，游戏权益，盼之代售'
				}
			]
		}
	}
}
